<template>
    <div
        v-if="badgeInfo"
        :class="[$style.badge, $style[badgeInfo.id], isHide && $style.hidden, props.className]"
        :aria-label="badgeInfo.id"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BadgeType } from '@/types'

interface BadgesProps {
    badges: BadgeType[] | undefined
    isHide?: boolean
    className?: string
}
const props = defineProps<BadgesProps>()

const badgeInfo = computed(() => {
    const priority = ['hot', 'top', 'new']
    const id = props.badges?.find((b) => priority.includes(b))

    if (!id) {
        return null
    }

    return {
        id,
    }
})
</script>

<style module>
.badge {
    position: absolute;
    top: -6px;
    left: -8px;

    height: 34px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    filter: opacity(100%);
    transition: all 0.4s ease-in-out;
    pointer-events: none;
}

.hot {
    background-image: url('./images/hot-text.webp');
    width: 64px;
    height: 34px;
}

.new {
    background-image: url('./images/new.webp');
    width: 34px;
    height: 34px;
}

.top {
    background-image: url('./images/top-text.webp');
    width: 64px;
    height: 34px;
}

.hidden {
    filter: opacity(0%);
}
</style>
